import styled from '@emotion/styled'

const StyledDescription = styled.label`
  font-size: 12px;
  color: #8094ae;
`

export default StyledDescription
